import { z } from 'zod';

export const archiveEvaluationSessionSchema = z.object({
  evaluation_session_id: z.uuid(),
});

export type ArchiveEvaluationSessionPayload = z.infer<typeof archiveEvaluationSessionSchema>;
